module.exports = __webpack_public_path__ + "static/media/toy-logo2.de457a1d.svg";